/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import { object, bool, func, string } from 'prop-types';
import {
  Modal,
  ModalHeader,
  ModalFooter,
  Stepper,
  useBreakpoint,
} from '@one-thd/sui-atomic-components';
import DimensionsBar from './DimensionsBar';
import { useDesignStore } from '../../../store/design/context';
import logNewRelicCustom from '../../../utils/logNewRelicCustom';
import { NEW_RELIC_EVENTS } from '../../../constants';

const StackModal = ({
  open,
  handleClose,
  backgroundImage,
  children,
}) => {
  const [scale, setScale] = useState();
  const design = useDesignStore((state) => state.design);
  const matches = useBreakpoint('lg');
  const isDesktop = matches.greater;

  const onClose = () => {
    setScale(100);
    handleClose();
  };

  const onQuantityChange = (count) => {
    const increase = count > scale;
    setScale(count);
    logNewRelicCustom(
      increase
        ? NEW_RELIC_EVENTS.ZOOM_IN
        : NEW_RELIC_EVENTS.ZOOM_OUT,
      { ...design, zoomValue: count }
    );
  };

  return (
    <Modal
      size={isDesktop ? 'md' : 'lg'}
      open={open}
      onClose={handleClose}
    >
      <div
        className="modal--container"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: '100% 125%',
        }}
      >
        <ModalHeader onClose={onClose}>
          <div className="sui-block sui-text-inverse sui-text-center">Zoom:</div>
          <div className="quantity-stepper">
            <Stepper
              style={{ justifyContent: 'center' }}
              min={100}
              max={200}
              step={30}
              value={scale}
              defaultValue={100}
              onChange={onQuantityChange}
            />
          </div>
        </ModalHeader>
        <div
          className="sui-flex sui-flex-col sui-flex-auto sui-overflow-y-auto sui-overflow-x-hidden sui-px-6 sui-pt-2 modal--body"
        >
          <div
            className="modal--stack"
            style={{
              transform: `scale(${scale / 100})`,
              marginBottom: `${0.04 + (scale / 100)}px`,
              transformOrigin: 'top',
            }}
          >
            {children}
          </div>
        </div>
        <ModalFooter
          style={{ paddingTop: 0 }}
        >
          <div className="visualizer__dimensions">
            <DimensionsBar />
          </div>
        </ModalFooter>
      </div>
    </Modal>
  );
};

StackModal.propTypes = {
  open: bool,
  handleClose: func,
  children: object,
  backgroundImage: string,
};

StackModal.defaultProps = {
  open: false,
  handleClose: func,
  children: {},
  backgroundImage: '',
};

export default StackModal;
